import { render, staticRenderFns } from "./disputeAdd.vue?vue&type=template&id=657195d8&scoped=true&"
import script from "./disputeAdd.vue?vue&type=script&lang=js&"
export * from "./disputeAdd.vue?vue&type=script&lang=js&"
import style0 from "./disputeAdd.vue?vue&type=style&index=0&id=657195d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657195d8",
  null
  
)

export default component.exports